"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bot = void 0;
var bot = {
  prefix: 'ddsCustom',
  iconName: 'bot',
  icon: [20, 16, [], '', 'M6.3,9.59a1.24,1.24,0,1,1-1.24,1.24A1.24,1.24,0,0,1,6.3,9.59Zm7.37,0a1.25,1.25,0,1,1-1.25,1.25A1.25,1.25,0,0,1,13.67,9.57ZM12,5.22V4.43H10.56v-2a1.26,1.26,0,0,0,.8-1.18A1.22,1.22,0,0,0,10.09,0,1.28,1.28,0,0,0,8.81,1.27a1.29,1.29,0,0,0,.8,1.18v2H8.19v.79H3.09a1.5,1.5,0,0,0-1.6,1.36v8.16a1.49,1.49,0,0,0,1.6,1.35H16.91a1.49,1.49,0,0,0,1.6-1.35V6.58a1.5,1.5,0,0,0-1.6-1.36H12.39m4.52,9.52H3.09V6.58H16.91Z']
};
exports.bot = bot;